export default function Paragraph ({ children, className, ...attributes }) {
  return <p {...attributes} className={`mb-4 text-medium md:text-base md:mb-8 ${className}`}>{children}</p>
}

